/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
// ==============================
// Popup Open/Close for any page - Added by Celine to make hyperlink for newletter popup
// ==============================

/*
// Function to open the newsletter popup
function openNewsletterPopup() {
  var popup = document.getElementById('popup--popup-0'); // Your popup ID
  if (popup) {
    popup.classList.add('popup--visible');
    document.body.classList.add('popup-open'); // Lock scroll if theme uses it
  }
}

// Function to close the newsletter popup
function closeNewsletterPopup() {
  var popup = document.getElementById('popup--popup-0');
  if (popup) {
    popup.classList.remove('popup--visible');
    document.body.classList.remove('popup-open');
  }
}

// Attach close event to existing close button inside popup
document.addEventListener('DOMContentLoaded', function() {
  // Listen for clicks on any link with href="#newsletter-popup"
  document.querySelectorAll('a[href="#newsletter-popup"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault(); // prevent default page jump
      // Open the popup by adding the visible class
      var popup = document.querySelector('#popup--popup-0'); // change ID if needed
      if (popup) {
        popup.classList.add('popup--visible');
        document.body.classList.add('popup-open'); // optional if your theme locks scroll
      }
    });
  });

  // Close button
  var closeButtons = document.querySelectorAll('#popup--popup-0 .popup__close');
  closeButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var popup = document.querySelector('#popup--popup-0');
      popup.classList.remove('popup--visible');
      document.body.classList.remove('popup-open');
    });
  });
});
*/

// Open the Shopify Forms signup popup (AU or US, whichever the visitor sees)
// when the "Sign up" link in the announcement bar is clicked. #popup--popup-0
// (the old target) is a disabled legacy section - the real live popup is the
// Shopify Forms app embed, which has no public JS API, so we drive its own
// "teaser" reopen button (visible whenever the dialog isn't already open).
(function () {
  var TRIGGER_HOST_IDS = {
    '#au-signup-popup': 'app-embed-container-1098641',
    '#us-signup-popup': 'app-embed-container-1081500'
  };
  var POLL_INTERVAL_MS = 250;
  var POLL_TIMEOUT_MS = 10000;

  function openPopup(hostId) {
    var elapsed = 0;
    var intervalId = setInterval(function () {
      elapsed += POLL_INTERVAL_MS;
      var host = document.getElementById(hostId);
      var root = host && host.shadowRoot;
      var teaser = root && root.querySelector('[data-testid="form-teaser"]');
      var dialogAlreadyOpen = root && root.querySelector('[role="dialog"]');

      if (teaser) {
        clearInterval(intervalId);
        teaser.click();
      } else if (dialogAlreadyOpen || elapsed >= POLL_TIMEOUT_MS) {
        clearInterval(intervalId);
      }
    }, POLL_INTERVAL_MS);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link) return;

    var hostId = TRIGGER_HOST_IDS[link.getAttribute('href')];
    if (!hostId) return;

    e.preventDefault();
    openPopup(hostId);
  });
})();



/*End of custom code added by Celine to make popup show from hyperlink*/

/*Custom code to make announcmeent bar sticky

document.addEventListener("DOMContentLoaded", function() {
  var bar = document.querySelector('[data-announcement-bar]');
  if (bar) {
    bar.classList.add('announcement-bar-sticky');

    // Optional: recalc Flickity positions after changing CSS
    var flickityInstance = bar.querySelector('.flickity-enabled');
    if (flickityInstance && flickityInstance.flickity) {
      flickityInstance.flickity.resize();
    }
  }
});

/*End of custom code to make announcmeent bar sticky*/





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
